import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { BASE_DEV_URL } from '../../config/api.config'
import { ID_TOKEN } from '../../config/app.config'
import axios from 'axios'
import Card from './Card'
import {
  IonContent,
  IonHeader,
  IonPage,
  useIonViewDidEnter,
} from '@ionic/react'
import Toolbar from '../../components/Toolbar/Toolbar'
import './index.css'
import moment from 'moment'
import BonusBanner from './BonusBanner'
import BonusModal from './BonusModal'

const width = window.innerWidth

export default function Bonuses() {
  const history = useHistory()
  const [selectedType, setSelectedType] = useState('ALL')
  const [open, setOpen] = useState(false)
  const [bonusItem, setBonusItem] = useState({})
  const [bonuses, setBonuses] = useState([])
  const [activeBonuses, setActiveBonuses] = useState([])
  const [awaitingBonuses, setAwaitingBonuses] = useState([])
  const [expiredBonuses, setExpiredBonuses] = useState([])

  const gotoEvent = () => {
    console.log('clicked')

    history.push('/')
  }

  useIonViewDidEnter(() => {
    const token = localStorage.getItem(`${ID_TOKEN}`)
    token &&
      axios
        .get(`${BASE_DEV_URL}/account/bonuses?bonusType=all`, {
          headers: {
            Authorization: token,
          },
        })
        .then(function (response) {
          console.log(response)
          setBonuses(response.data.result)
          response.data.result.length !== 0 &&
            setActiveBonuses(
              response.data.result.filter((a) => a.STS_ID === 20)
            )
          setExpiredBonuses(response.data.result.filter((a) => a.STS_ID === 30))
          setAwaitingBonuses(
            response.data.result.filter((a) => a.STS_ID === 10)
          )
          // response.data.result.map((bonus) => {
          //   if (bonus.STS_ID === 20) {
          //     setActiveBonuses((prev) => [...prev, bonus])
          //   } else if (bonus.STS_ID === 30) {
          //     setExpiredBonuses((prev) => [...prev, bonus])
          //   } else if (bonus.STS_ID === 10) {
          //     setAwaitingBonuses((prev) => [...prev, bonus])
          //   }
          // })
        })
        .catch(function (error) {
          console.log(error)
        })
  })
  const [bonusData, setBopnusData] = useState()
  const fetchgetLockedBonusProgress = () => {
    const token = localStorage.getItem(`${ID_TOKEN}`)
    token &&
      axios
        .post(
          `${BASE_DEV_URL}user/getLockedBonusProgress`,
          {
            limit: 10,
            page: 1,
            status: selectedType,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then(function (response) {
          setBopnusData(response?.data?.data)
        })
        .catch(function (error) {
          console.log(error)
        })
  }

  useEffect(() => {
    fetchgetLockedBonusProgress()
  }, [selectedType])

  const handleInfoBonus = (item) => {
    setOpen(true)
    setBonusItem(item)
  }

  return (
    <>
      {width < 1024 ? (
        <IonPage>
          <div className="lg:hidden">
            <IonHeader>
              <Toolbar />
            </IonHeader>
          </div>
          <IonContent>
            <div className="bonuses">
              <div className="bonuses-wrapp">
                <div className="bonuses-conteiner">
                  <span className="bonuses-text">Your Bonuses</span>
                </div>
              </div>

              <div className="MyOpenBets__page-menu-buttons-wrapper">
                <div className="MyOpenBets__page-menu-buttons-row MyOpenBets__page-menu-buttons-row-time bonus_active">
                  <div
                    onClick={() => setSelectedType('ALL')}
                    className={`MyOpenBets__page-menu-button ${
                      selectedType === 'ALL' ? 'active' : ''
                    }`}
                  >
                    <span>All</span>
                  </div>
                  <div
                    onClick={() => setSelectedType('ACTIVE')}
                    className={`MyOpenBets__page-menu-button ${
                      selectedType === 'ACTIVE' ? 'active' : ''
                    }`}
                  >
                    <span>Active</span>
                  </div>
                  <div
                    onClick={() => setSelectedType('INACTIVE')}
                    className={`MyOpenBets__page-menu-button ${
                      selectedType === 'INACTIVE' ? 'active' : ''
                    }`}
                  >
                    <span>InActive</span>
                  </div>
                  <div
                    onClick={() => setSelectedType('CLAIMED')}
                    className={`MyOpenBets__page-menu-button ${
                      selectedType === 'CLAIMED' ? 'active' : ''
                    }`}
                    style={{ marginLeft: '0px' }}
                  >
                    <span>Claimed</span>
                  </div>
                </div>
              </div>

              <div className="bonuses-deposit">
                <div className="bonuses-deposit">
                  {bonusData?.length > 0 ? (
                    bonusData?.map((item) => {
                      const progressPercent =
                        (item?.used_rolling_amount * 100) /
                        item?.total_rolling_amount
                      const activeBonus = item?.created_at && item?.expire_at
                      return (
                        <div className="deposit-wrrap">
                          {selectedType == 'Expire' && (
                            <div className="deposit-expired">
                              <div className="deposit-expired-text">
                                Expired
                              </div>
                            </div>
                          )}

                          <div
                            className={`expired font-semibold ${
                              selectedType == 'Expire'
                                ? 'plus-bg-slate-700'
                                : activeBonus
                                ? 'plus-bg-green-500'
                                : 'plus-bg-orange-500'
                            }`}
                          >
                            <div className="shimmer-animation"></div>
                            Active Bonus
                          </div>

                          <svg
                            onClick={() => handleInfoBonus(item)}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="info-icon"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                              clip-rule="evenodd"
                            />
                          </svg>

                          <div className="deposit-container">
                            <div className="deposit-title">
                              <span
                                className="deposit-title-text"
                                style={{ fontSize: '15px' }}
                              >
                                {item?.bonus_type?.replace(/_/g, ' ')}
                              </span>
                            </div>
                            <span className="deposit-descr">
                              Unlocked bonus amount: ₹
                              {item?.unlocked_bonus_amount}
                            </span>
                            <span className="deposit-descr">
                              Locked bonus amount: ₹
                              {item?.total_locked_bonus_amount}
                            </span>
                            <div className="deposit-timer">
                              <svg
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M4 0C3.44772 0 3 0.447715 3 1C3 1.55228 3.44772 2 4 2H8C8.55228 2 9 1.55228 9 1C9 0.447715 8.55228 0 8 0H4ZM6 15C9.31371 15 12 12.3137 12 9C12 5.68629 9.31371 3 6 3C2.68629 3 0 5.68629 0 9C0 12.3137 2.68629 15 6 15ZM9.07849 6.06775C9.32063 5.74159 9.28723 5.28725 8.99998 5L4.9685 8.60646C4.5823 8.95195 4.56564 9.55094 4.93205 9.91735C5.32169 10.307 5.96649 10.2596 6.29495 9.81715L9.07849 6.06775Z"
                                  fill="white"
                                />
                              </svg>
                              Expiry:{' '}
                              {moment(item?.expire_at).format(
                                'DD/MM/YYYY HH:mm:ss'
                              )}
                            </div>

                            <div className="line"></div>
                            <span className="procent">
                              {progressPercent?.toFixed()}%
                            </span>
                          </div>
                        </div>
                      )
                    })
                  ) : (
                    <div style={{ color: '#000', textAlign: 'center' }}>
                      No Bonud Data Found!
                    </div>
                  )}
                </div>

                {/* {activeBonuses?.map((x, index) => (
          <Card
            expired={false}
            key={index}
            activeBonusAvailable={activeBonuses.length !== 0}
            x={x}
          />
        ))}
        {awaitingBonuses?.map((x, index) => (
          <Card
            expired={false}
            key={index}
            activeBonusAvailable={activeBonuses.length !== 0}
            x={x}
          />
        ))}

        {expiredBonuses?.map((x, index) => (
          <Card
            expired={true}
            key={index}
            activeBonusAvailable={activeBonuses.length !== 0}
            x={x}
          />
        ))} */}
              </div>
            </div>
          </IonContent>
        </IonPage>
      ) : (
        <div className="bonuses">
          <div className="bonuses-wrapp">
            <div className="bonuses-conteiner">
              <span className="bonuses-text">Your Bonuses</span>
            </div>
          </div>

          <div className="MyOpenBets__page-menu-buttons-wrapper">
            <div className="MyOpenBets__page-menu-buttons-row MyOpenBets__page-menu-buttons-row-time bonus_active">
              <div
                onClick={() => setSelectedType('ALL')}
                className={`MyOpenBets__page-menu-button ${
                  selectedType === 'ALL' ? 'active' : ''
                }`}
              >
                <span>All</span>
              </div>
              <div
                onClick={() => setSelectedType('ACTIVE')}
                className={`MyOpenBets__page-menu-button ${
                  selectedType === 'ACTIVE' ? 'active' : ''
                }`}
              >
                <span>Active</span>
              </div>
              <div
                onClick={() => setSelectedType('INACTIVE')}
                className={`MyOpenBets__page-menu-button ${
                  selectedType === 'INACTIVE' ? 'active' : ''
                }`}
              >
                <span>InActive</span>
              </div>
              <div
                onClick={() => setSelectedType('CLAIMED')}
                className={`MyOpenBets__page-menu-button ${
                  selectedType === 'CLAIMED' ? 'active' : ''
                }`}
                style={{ marginLeft: '0px' }}
              >
                <span>Claimed</span>
              </div>
            </div>
          </div>

          <div className="bonuses-deposit">
            {bonusData?.length > 0 ? (
              bonusData?.map((item) => {
                const progressPercent =
                  (item?.used_rolling_amount * 100) / item?.total_rolling_amount
                const activeBonus = item?.created_at && item?.expire_at
                return (
                  <div className="deposit-wrrap" style={{ maxWidth: '22rem' }}>
                    {selectedType == 'Expire' && (
                      <div className="deposit-expired">
                        <div className="deposit-expired-text">Expired</div>
                      </div>
                    )}

                    <div
                      className={`expired font-semibold ${
                        selectedType == 'Expire'
                          ? 'plus-bg-slate-700'
                          : activeBonus
                          ? 'plus-bg-green-500'
                          : 'plus-bg-orange-500'
                      }`}
                    >
                      <div className="shimmer-animation"></div>
                      Active Bonus
                    </div>

                    <svg
                      onClick={() => handleInfoBonus(item)}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      class="info-icon"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                        clip-rule="evenodd"
                      />
                    </svg>

                    <div className="deposit-container">
                      <div className="deposit-title">
                        <span
                          className="deposit-title-text"
                          style={{ fontSize: '15px' }}
                        >
                          {item?.bonus_type?.replace(/_/g, ' ')}
                        </span>
                      </div>
                      <span className="deposit-descr">
                        Unlocked bonus amount: ₹{item?.unlocked_bonus_amount}
                      </span>
                      <span className="deposit-descr">
                        Locked bonus amount: ₹{item?.total_locked_bonus_amount}
                      </span>
                      <div className="deposit-timer">
                        <svg
                          width="12"
                          height="15"
                          viewBox="0 0 12 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4 0C3.44772 0 3 0.447715 3 1C3 1.55228 3.44772 2 4 2H8C8.55228 2 9 1.55228 9 1C9 0.447715 8.55228 0 8 0H4ZM6 15C9.31371 15 12 12.3137 12 9C12 5.68629 9.31371 3 6 3C2.68629 3 0 5.68629 0 9C0 12.3137 2.68629 15 6 15ZM9.07849 6.06775C9.32063 5.74159 9.28723 5.28725 8.99998 5L4.9685 8.60646C4.5823 8.95195 4.56564 9.55094 4.93205 9.91735C5.32169 10.307 5.96649 10.2596 6.29495 9.81715L9.07849 6.06775Z"
                            fill="white"
                          />
                        </svg>
                        Expiry:{' '}
                        {moment(item?.expire_at).format('DD/MM/YYYY HH:mm:ss')}
                      </div>

                      <div className="line"></div>
                      <span className="procent">
                        {progressPercent?.toFixed()}%
                      </span>
                    </div>
                  </div>
                )
              })
            ) : (
              <div style={{ color: '#000', textAlign: 'center' }}>
                No Bonud Data Found!
              </div>
            )}
          </div>
        </div>
      )}
      {open && <BonusModal setOpen={setOpen} item={bonusItem} />}
    </>
  )
}
